import { useIcp } from "../../logic/hooks/useIcp.js";
import { EntityPageHeader, EntityToolbar, EntityEmptyState, EntityLoadingState } from "../../components/ui/EntityPageChrome.jsx";
import { EntityTable } from "../../components/ui/EntityTable.jsx";
import { StatusBadge, useThemeSlice } from "../../components/ui/StatusBadge.jsx";

const COLUMNS = [
  { key: "name", label: "Profile" },
  { key: "industry", label: "Industry" },
  { key: "segment", label: "Segment" },
  { key: "fleetSize", label: "Fleet size" },
  { key: "region", label: "Region" },
  { key: "status", label: "Status" },
];

export function IcpPage() {
  const { items, loading, search, setSearch, total } = useIcp();
  const { c, accentHex } = useThemeSlice();

  const renderCell = (row, key) => {
    if (key === "status") return <StatusBadge label={row.status} colors={c} accent={accentHex} />;
    return row[key];
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <EntityPageHeader title="ICP" subtitle="Ideal customer profiles" count={total} />
      <EntityToolbar search={search} onSearchChange={setSearch} placeholder="Search ICP profiles…" />
      {loading ? (
        <EntityLoadingState />
      ) : items.length === 0 ? (
        <EntityEmptyState message="No ICP profiles found" />
      ) : (
        <EntityTable columns={COLUMNS} rows={items} renderCell={renderCell} />
      )}
    </div>
  );
}
